
<div class="col-md-12 container">
  <div class="form-container">
    <form [formGroup]="form">
      <a routerLink="/">
        <img src="/assets/logo-posso-agendar-borda-azul-desktop.svg" alt="Posso Agendar?" class="login-img hidden-xs" />
        <img src="/assets/logo-posso-agendar-borda-azul.svg" alt="Posso Agendar?" class="login-img visible-xs" />
      </a>
      <!-- Conteúdo do formulário aqui -->
      <page-alert message="Usuário confirmado com sucesso!" *ngIf="successConfirmation && submitted" alertClass="alert-success"></page-alert>
      <page-alert message="Falha ao confirmar usuário. Tente novamente" *ngIf="!successConfirmation && submitted" alertClass="alert-danger"></page-alert>
      <p>Digite abaixo o código de confirmação enviado para o seu E-mail:</p>
      <mat-form-field appearance="outline" class="align-center container-center">
        <mat-icon matSuffix>account_circle</mat-icon>
        <mat-label>Código</mat-label>
        <input matInput placeholder="Digite o código" formControlName="code" />
        <mat-error *ngIf="form.get('code')?.hasError('required')">O código é obrigatório</mat-error>
      </mat-form-field>
      <div class="row">
        <button  class="mt-2" mat-raised-button color="primary" (click)="confirmCode()">Confirmar Código</button>
        <button  class="mt-2" mat-raised-button color="primary" (click)="reSendCode()" [disabled]="countdownActive">{{ buttonLabel }}</button>
      </div>      
    </form>
  </div>
</div>
